module.exports = __webpack_public_path__ + "img/ML.96ef0f08.svg";